module.exports = __webpack_public_path__ + "img/bg3.8cce3097.jpg";